import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { LocalStoreService } from './local-store.service';
import { Utils } from '../../shared/utils';
import { NotificationService } from './notificacion.service';
import { decodeJwtPayload, isJwtExpired } from './jwt.utils';

@Injectable({
	providedIn: 'root',
})
export class AuthService {
	//Only for demo purpose
	authenticated = true;
	private apiUrl: string = '';

	constructor(
		private store: LocalStoreService,
		private utils: Utils,
		private http: HttpClient,
		private router: Router,
		private notificationService: NotificationService,
	) {
		this.apiUrl = this.utils.ServerWithApiUrl + 'auth';
		this.checkAuth();
	}

	checkAuth() {
		// this.authenticated = this.store.getItem("demo_login_status");
	}

	getuser() {
		var user = localStorage.getItem('currentUserPortal');
		if (user != null) {
			return JSON.parse(user);
		}
		return null;
	}

	getUserAdmin() {
		//Yo creo que no se usa
		var user = localStorage.getItem('currentUserAdminPortal');
		if (user != null) {
			return JSON.parse(user);
		}
		return null;
	}

	getUserPortal() {
		//Yo creo que no se usa
		var user = localStorage.getItem('currentUserAdPortal');
		if (user != null) {
			return JSON.parse(user);
		}
		return null;
	}

	signin(credentials: any) {
		const data = {
			rut: '0-0',
			email: credentials.correo,
			password: credentials.pass,
		};

		const body = JSON.stringify(data);
		return this.http.post(
			this.apiUrl + '/authenticate',
			body,
			this.utils.getHeaders(false),
		);
	}

	signinPayment(credentials: any) {
		const data = {
			rut: credentials.rutLogin,
			email: credentials.correo,
			password: credentials.pass,
            captchaToken: credentials.captchaToken,
		};
		const body = JSON.stringify(data);
		return this.http.post(
			this.apiUrl + '/authenticate',
			body,
			this.utils.getHeaders(false),
		);
	}

	signout() {
		this.ClearSession();
		this.router.navigateByUrl('/sessions/signin');
	}

	signoutPayment(withRedirect: boolean = true) {
		this.ClearSession();
		if (withRedirect) {
			this.router.navigateByUrl('/sessions/paymentportal');
		}
	}

	ClearSession() {
		// this.store.removeItem('currentUserAd');
		this.store.removeItem('currentUserPortal');
		this.store.setItem('interceptorState', '0');
	}

	isLogged(): boolean {
		var currentUserAd = this.store.getItem('currentUserPortal');
		if (currentUserAd) {
			return true;
		}
		return false;
	}

	isLoggedPortal(): boolean {
		var currentUserAdPortal = this.store.getItem('currentUserPortal');
		if (currentUserAdPortal) {
			return true;
		}
		return false;
	}

	async signoutExpiredToken() {
		const response = await this.notificationService.sesionExpiredMsg(
			'Sesión Expirada',
			'Será redirigido al inicio de sesión en unos segundos',
		);
		if (response.isConfirmed) {
			this.signout();
		} else {
			this.signout();
		}
	}

	saveSession(res: any) {
		this.store.setItem('currentUserPortal', res);
	}

	getToken(): string | null {
		const user = this.store.getItem('currentUserPortal');
		return user?.token ?? null;
	}

	getPayload(): any | null {
		const token = this.getToken();
		if (!token) {
			return null;
		}

		const payload = decodeJwtPayload(token);
		if (!payload) {
			return null;
		}

		const emailClaim: string =
			payload.email ?? payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'];

		return {
			...payload,
			email: emailClaim,
		};
	}



	getRole(): string | null {
		const p = this.getPayload();
		// .NET ClaimTypes.Role usually becomes this URI key in payload
		return (
			p?.role ??
			p?.[
				'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'
			] ??
			null
		);
	}

	isTokenExpired(): boolean {
		const token = this.getToken();
		return token ? isJwtExpired(token) : true;
	}
}
